var _path, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPro(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 21,
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7844_34026",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 21,
    height: 21
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.7022 0H0V20.7022H20.7022V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7844_34026)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.7021 7.76331C20.5905 8.38962 20.3416 8.98348 19.9733 9.5023L12.3971 19.6981C12.1569 20.0085 11.8493 20.2601 11.4976 20.434C11.1458 20.6079 10.7591 20.6995 10.3667 20.7019C9.97421 20.7044 9.5864 20.6175 9.23252 20.4479C8.87865 20.2783 8.568 20.0305 8.32397 19.7231L0.710779 9.31603C0.38737 8.84737 0.15905 8.31984 0.0388039 7.76331H5.44552L9.54539 18.4241C9.6078 18.5872 9.71823 18.7275 9.86208 18.8265C10.0059 18.9255 10.1764 18.9785 10.3511 18.9785C10.5257 18.9785 10.6962 18.9255 10.8401 18.8265C10.9839 18.7275 11.0943 18.5872 11.1568 18.4241L15.2566 7.76331H20.7021ZM15.2678 6.03812H20.6651C20.5339 5.45452 20.2821 4.90478 19.9259 4.42424L17.7193 1.44487C17.3998 0.998263 16.9784 0.634207 16.4901 0.382944C16.0019 0.131682 15.4607 0.000444171 14.9116 1.54838e-06H13.0139L15.2678 6.03812ZM9.58161 1.54838e-06L7.28801 6.03812H13.4228L11.1748 1.54838e-06H9.58161ZM5.44293 6.03812L7.73572 1.54838e-06H5.73278C5.18828 -0.000514845 4.65145 0.128141 4.16634 0.375419C3.68122 0.622698 3.26176 0.981518 2.94226 1.42244L0.809115 4.21894C0.400943 4.75377 0.123787 5.37684 0 6.03812H5.44293ZM13.4081 7.76331H7.29406L10.3511 15.7113L13.4081 7.76331Z",
    fill: "#2679F3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPro);
export default __webpack_public_path__ + "static/media/icon-pro.1f856b94c68bf81de75122100c9e4d06.svg";
export { ForwardRef as ReactComponent };